// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__1RTq5","title_box":"styles_title_box__1AvGq","more":"styles_more__3nrF_"};